// Sprite frame loading — adapts the Vite glob pattern from
// ~/avengers-match/src/game/assets.ts, minus Phaser. Frames are plain PNG URLs
// the React <Sprite> cycles through. Drop a new folder under assets/sprites/ and
// its frames auto-load (e.g. a future Ninjago roster) with no code change.

const spriteUrls = import.meta.glob('../assets/sprites/**/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

function collectFrames(substring: string): string[] {
  return Object.entries(spriteUrls)
    .filter(([path]) => path.includes(substring))
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([, url]) => url);
}

export type HeroKind = 'idle' | 'celebrate';

/** Ordered frame URLs for a hero animation, e.g. heroFrames('spidey', 'idle'). */
export function heroFrames(heroId: string, kind: HeroKind): string[] {
  return collectFrames(`sprites/${heroId}/${kind}_`);
}
